var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoTwitter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.63,
    height: 15.922,
    viewBox: "0 0 19.63 15.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M44.216,17.922A11.349,11.349,0,0,0,55.667,6.471V5.926A8.864,8.864,0,0,0,57.63,3.854a9.053,9.053,0,0,1-2.29.654,4.243,4.243,0,0,0,1.745-2.181,10,10,0,0,1-2.508.981A3.9,3.9,0,0,0,51.632,2,4.1,4.1,0,0,0,47.6,6.035a2.126,2.126,0,0,0,.109.872,11.275,11.275,0,0,1-8.288-4.253,4.176,4.176,0,0,0-.545,2.072,4.333,4.333,0,0,0,1.745,3.381,3.676,3.676,0,0,1-1.854-.545h0a3.986,3.986,0,0,0,3.272,3.926,3.362,3.362,0,0,1-1.091.109,1.856,1.856,0,0,1-.763-.109A4.131,4.131,0,0,0,44,14.323a8.234,8.234,0,0,1-5.016,1.745A3.019,3.019,0,0,1,38,15.959a10.293,10.293,0,0,0,6.216,1.963",
    transform: "translate(-38 -2)",
    fill: "#273375",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoTwitter1);
export default __webpack_public_path__ + "static/media/picto_twitter_1.1cec6eca92f17e59a1056b1c0934ec4f.svg";
export { ForwardRef as ReactComponent };